import { render } from "./Promo-codes.vue?vue&type=template&id=31f0281e&scoped=true"
import script from "./Promo-codes.vue?vue&type=script&lang=js"
export * from "./Promo-codes.vue?vue&type=script&lang=js"

import "./Promo-codes.vue?vue&type=style&index=0&id=31f0281e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f0281e"]])

export default __exports__